const iconMapping: Record<string, string> = {
  'Мороженое': 'icecream-icon',
  'Хоз.товары': 'h_goods',
  'Под заказ': 'h_goods',
  'zagotovka': 'zagotovka',
  'Продукты': 'products',
  'Готовое': 'r_made',
  'Напитки': 'drinks',
  'Пиво': 'beer',
  'Горячее': 'hotter',
  'Сувенир': 'gift'
};

export default iconMapping;